<template>
    <div>
        <!-- 标题 -->
        <center-title>{{$t("message.caddress.title")}}</center-title>
        <!-- 表格 -->
        <address-table
            v-model="search"
            :prop-attr="sortAttr"
            :order="sortMode"
            :current-page="page.current_page"
            :page-count="page.last_page"
            @handleSearch="handleSearch"
            @selection-change="handleSelectionChange"
            @handleSort="handleSort"
            @current-change="handleCurrent"
            @handleModify="getAddressDetail"
            @handleDelete="handleDel"
            @batch-del="handleBatchDel">
        </address-table>
        <!-- 模态框 -->
        <address-dialog
            @handleModify="handleModify"
            @handleClose="handleCloseDialog">
            <template #form>
                <address-form
                    ref="editForm"
                    :key="editForm"
                    :address-detail="address_detail">
                </address-form>
            </template>
        </address-dialog>
        <!-- 添加 -->
        <address-add>
            <template #addForm>
                <address-form :key="addForm">
                    <template #submit="{ form, rule }">
                        <el-button
                            type="primary"
                            @click="handleSubmit(form, rule)">
                            <span>{{$t("public.submitBtn")}}</span>
                        </el-button>
                    </template>
                </address-form>
            </template>
        </address-add>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { tableRouterView } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableRouterView ],
    computed: mapState({
        power: state => state.user.power,
        page: state => state.user.page,
        address_detail: state => state.user.address_detail
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        addressTable: () => import("@/components/center/addressTable"),
        addressDialog: () => import("@/components/center/addressDialog"),
        addressAdd: () => import("@/components/center/addressAdd"),
        addressForm: () => import("@/components/center/addressForm")
    },
    methods: {
        ...mapMutations([
            "setAddressList",
            'handleDialog',
            'setAddressDetail',
            'setPage'
        ]),
        ...mapActions([
            "getAddressList",
            'getAddressDetail',
            'handleAddAddress',
            'handleDelAddress'
        ]),
        // 查
        getAddressData(search, attr, mode, page = 1) {
            this.getAddressList({
                search,
                attr,
                mode,
                page
            })
        },
        changeRouter(search, attr, mode, page = 1) {
            this.$router.push({
                name: 'address',
                query: {
                    search,
                    attr,
                    mode,
                    page
                }
            }).catch(err => err)
        },
        // 删
        handleDel(res) {
            if(res){
                this.$message({
                    showClose: true,
                    message: this.$t("public.delSucc"),
                    type: "success"
                })
                setTimeout(() => {
                    this.getAddressData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
                },1000)
            }else{
                // delete Address fail and do something
            }
        },
        handleBatchDel() {
            this.$confirm(this.$t("message.caddress.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => {
                let list = this.selectedList.map(element => {
                    return element.address_id
                });
				if(list.length==0){
					this.$message({
						showClose: true,
						message: '請選擇刪除收貨地址',
						type: "error"
					})
					return
				}
                let id = list.join();
                return this.handleDelAddress(id)
            }).then((res) => {
                this.handleDel(res)
            }).catch(() => {})
        },
        // 增
        handleSubmit(form, rule) {
            let r1 = rule.rule1.validate(),
                r2 = rule.rule2.validate();
            
            Promise.all(
                [r1, r2]
            ).then(() => {
                this.handleAddAddress({
                    consignee: form.consignee,
                    address: form.address,
                    mobile: form.mobile,
                    email: form.email,
                    fax: form.fax,
                    status: form.is_default? 0: 1,
                }).then((res) => {
                    if(res){
                        this.addForm = this.addForm == 0? 1: 0;
                        this.$message({
                            showClose: true,
                            message: this.$t("public.addSucc"),
                            type: "success"
                        })
                        setTimeout(() => {
                            this.getAddressData(this.search, this.sortAttr, this.sortMode, this.$route.query.page)
                        },1000)
                    }else{
                        // add Address fail and do something
                    }
                })
            }).catch(err => console.log('err=',err))
        },
        // 改
        handleCloseDialog() {
            this.handleDialog(false);
            this.setAddressDetail({});
            this.getAddressData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
        },
        handleModify(handleClose) {
            let form = this.$refs.editForm.form, 
            rule = this.$refs.editForm.$refs;

            let r1 = rule.rule1.validate(),
                r2 = rule.rule2.validate();
            
            Promise.all(
                [r1, r2]
            ).then(() => {
                this.handleAddAddress({
                    address_id: this.address_detail.address_id,
                    consignee: form.consignee,
                    address: form.address,
                    mobile: form.mobile,
                    email: form.email,
                    fax: form.fax,
                    status: form.is_default? 0: 1,
                    url: "/index/address/editpost"
                }).then((res) => {
                    if(res){
                        this.editForm = this.editForm == 0? 1: 0;
                        this.$message({
                            showClose: true,
                            message: this.$t("public.modifySucc"),
                            type: "success"
                        })
                        setTimeout(() => {
                            handleClose();
                        },1000)
                    }else{
                        // add Address fail and do something
                    }
                })
            }).catch(err => err)
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(111) || vm.power.includes(3);
				
				let {
				    search = '',
				    attr = '',
				    mode = '',
				    page = 1
				} = to.query;
				
				if(allow){
				    vm.getAddressData(search, attr, mode, page);
				}else{
				    vm.$router.back();
				    return false;
				}	
			}, 500)
           
        })
    },
    beforeRouteUpdate (to, from, next) {
        let {
            search,
            attr,
            mode,
            page
        } = to.query;

        this.getAddressData(search, attr, mode, page);
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setAddressList([]);
        this.setPage({});
        next();
    }
}
</script>